<template>
    <section id='register-user'>
        <div class="row">
            <div class="col-sm-12 blackBar">
                <div class="title">kontaktdaten</div>
            </div>
        </div>
        <div class="row backgroundGray">
            <div class="row">
                <div class="col-sm-6">
                    <div :class="formGroupClass('company')">
                        <div class="form-group">
                            <input class="form-control" id="company" type="text" name="company" placeholder="Firma" v-model="form.company" />
                            <div class="help-block" v-if="form.errors.has('company')">
                                <strong>{{ form.errors.get('company') }}</strong>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div :class="formGroupClass('vatin')">
                        <div class="form-group">
                            <input class="form-control" id="vatin" type="text" name="vatin" placeholder="UID" v-model="form.vatin"/>
                            <div class="help-block" v-if="form.errors.has('vatin')">
                                <strong>{{ form.errors.get('vatin') }}</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4">
                    <div :class="formGroupClass('salutation')">
                        <select class="form-control" v-model="form.salutation">
                            <option value="" disabled selected>Anrede</option>
                            <option value="Herr">Herr</option>
                            <option value="Frau">Frau</option>
                        </select>
                        <div class="help-block" v-if="form.errors.has('salutation')">
                            <strong>{{ form.errors.get('salutation') }}</strong>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <div :class="formGroupClass('firstname')">
                        <div class="form-group">
                            <input class="form-control" id="firstname" type="text" name="firstname" placeholder="Vorname" v-model="form.firstname" required="required" autofocus="autofocus"/>
                            <div class="help-block" v-if="form.errors.has('firstname')">
                                <strong>{{ form.errors.get('firstname') }}</strong>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div :class="formGroupClass('lastname')">
                        <div class="form-group">
                            <input class="form-control" id="lastname" type="text" name="lastname" placeholder="Nachname" v-model="form.lastname" required="required"/>
                            <div class="help-block" v-if="form.errors.has('lastname')">
                                <strong>{{ form.errors.get('lastname') }}</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div :class="formGroupClass('street')">
                        <div class="form-group">
                            <input class="form-control" id="street" type="text" name="street" placeholder="Straße und Hausnr." v-model="form.street" required="required"/>
                            <div class="help-block" v-if="form.errors.has('street')">
                                <strong>{{ form.errors.get('street') }}</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-8">
                    <div :class="formGroupClass('city')">
                        <div class="form-group">
                            <input class="form-control" id="city" type="text" name="city" placeholder="Ort" v-model="form.city" required="required"/>
                            <div class="help-block" v-if="form.errors.has('city')">
                                <strong>{{ form.errors.get('city') }}</strong>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div :class="formGroupClass('postalCode')">
                        <div class="form-group">
                            <input class="form-control" id="postalCode" type="text" name="postalCode" placeholder="PLZ" v-model="form.postalCode" required="required"/>
                            <div class="help-block" v-if="form.errors.has('postalCode')">
                                <strong>{{ form.errors.get('postalCode') }}</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div :class="formGroupClass('country')">
                        <div class="form-group">
                            <select class="form-control" id="country" name="country" v-model="form.country" required="required">
                                    <option value="" disabled selected>Land</option>
                                    <option v-for="country in countries" :key="country.id" :value="country.id" :selected="(country.id == form.country)">{{ country.name }}</option>
                            </select>
                            <div class="help-block" v-if="form.errors.has('country')">
                                <strong>{{ form.errors.get('country') }}</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12 blackBar"><div class="title">Email</div></div>
        </div>
        <div class="row backgroundGray">
            <div class="row">
                <div class="col-sm-8">
                    <div :class="formGroupClass('email')">
                        <div class="form-group">
                            <input class="form-control" id="email" type="email" name="email" placeholder="E-Mail" v-model="form.email" required="required"/>
                            <div class="help-block" v-if="form.errors.has('email')">
                                <strong>{{ form.errors.get('email') }}</strong>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div :class="formGroupClass('email_confirmation')">
                        <div class="form-group">
                            <input class="form-control" id="email_confirmation" type="email" name="email_confirmation" placeholder="E-Mail wiederholen" v-model="form.email_confirmation" required="required"/>
                            <div class="help-block" v-if="form.errors.has('email_confirmation')">
                                <strong>{{ form.errors.get('email_confirmation') }}</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="form.errors.has('global')">
            <div class="col-sm-12">
                <div class="alert alert-danger">
                    <i class="fa fa-exclamation-triangle"></i> 
                    {{ form.errors.get('global') }}
                </div>
            </div>
        </div>
    </section>
</template>

<script>

export default {

    data() {
        return {
            form: new Form({
                salutation: '',
                company: null,
                vatin: null,
                firstname: null,
                lastname: null,
                street: null,
                postalCode: null,
                city: null,
                country: '',
                email: null,
                email_confirmation: null
            }),
            countries: []
        }
    },

    methods: {
        formGroupClass(name) {
            return this.form.errors.has(name) ? 'form-group has-error' : 'form-group';
        }
    },

    created() {

        this.countries = App.countries;
        App.event.listen('countries.loaded', countries => this.countries = countries);

        //- register user
        App.event.listen('guest.send', () => {
            this.form.put('/guest').then(response => {
                App.event.fire('guest.success', response);
            }).catch(errors => {
                App.event.fire('guest.failed', errors);
            });
        });

    }
}
</script>
